import { BehaviorNode as BehaviorNodeType } from "../types.js";
import { ActionBehaviorNode } from "./nodes/ActionBehaviorNode.js";
import { AnimBeginBehaviorNode } from "./nodes/AnimBeginBehaviorNode.js";
import { AnimEndBehaviorNode } from "./nodes/AnimEndBehaviorNode.js";
import { AnimKeyframeBehaviorNode } from "./nodes/AnimKeyframeBehaviorNode.js";
import { AnimPlayBehaviorNode } from "./nodes/AnimPlayBehaviorNode.js";
import { BehaviorNode } from "./nodes/BehaviorNode.js";
import { ControlBehaviorNode } from "./nodes/ControlBehaviorNode.js";
import { CallBehaviorNode } from "./nodes/CallBehaviorNode.js";
import { SetVariableBehaviorNode } from "./nodes/SetVariableBehaviorNode.js";
import { VariableRefBehaviorNode } from "./nodes/VariableRefBehaviorNode.js";
import { CreateRowVariantBehaviorNode } from "./nodes/CreateRowVariantBehaviorNode.js";
import { EventBehaviorNode } from "./nodes/EventBehaviorNode.js";
import { OperatorBehaviorNode } from "./nodes/OperatorBehaviorNode.js";
import { VariableBehaviorNode } from "./nodes/VariableBehaviorNode.js";

export function createBehaviorNode(behavior: BehaviorNodeType): BehaviorNode {
  switch (behavior.type) {
    case "operator":
      return new OperatorBehaviorNode(behavior);
    case "variable":
      if (behavior.valueType === "variableRef") {
        return new VariableRefBehaviorNode(behavior);
      }
      return new VariableBehaviorNode(behavior);
    case "event":
      return new EventBehaviorNode(behavior);
    case "control":
      return new ControlBehaviorNode(behavior);
    case "action": {
      if (behavior.kind === "set") {
        return new ActionBehaviorNode(behavior);
      }
      if (behavior.kind === "animBegin") {
        return new AnimBeginBehaviorNode(behavior);
      }
      if (behavior.kind === "animKeyframe") {
        return new AnimKeyframeBehaviorNode(behavior);
      }
      if (behavior.kind === "animEnd") {
        return new AnimEndBehaviorNode(behavior);
      }
      if (behavior.kind === "animPlay") {
        return new AnimPlayBehaviorNode(behavior);
      }
      if (behavior.kind === "createRowVariant") {
        return new CreateRowVariantBehaviorNode(behavior);
      }
      if (behavior.kind === "call") {
        return new CallBehaviorNode(behavior);
      }
      if (behavior.kind === "setVariable") {
        return new SetVariableBehaviorNode(behavior);
      }
      throw new Error(
        `Unsupported action kind: ${(behavior as { kind?: string }).kind}`,
      );
    }
    default:
      throw new Error(
        `Unsupported behavior node type: ${(behavior as BehaviorNodeType).type}`,
      );
  }
}
